// ============================================================
// Sconti Incredibili — Configurazione centrale del sito
// Modifica qui URL Telegram, offerte demo, statistiche, FAQ
// e contenuti delle pagine legali.
// ============================================================

export const TELEGRAM_URL = "https://t.me/+oVGpbfR6h0ViNjFk";

export const SITE = {
    name: "Sconti Incredibili",
    tagline: "Le migliori offerte, direttamente su Telegram.",
};

// Statistiche in evidenza — valori dimostrativi, sostituisci con i dati reali.
export const STATS = [
    { id: "offerte", value: 10000, suffix: "+", label: "Offerte monitorate", demo: true },
    { id: "monitoraggio", value: null, display: "24/7", label: "Monitoraggio", demo: true },
    { id: "gratuito", value: 100, suffix: "%", label: "Accesso gratuito", demo: true },
];

// Offerte dimostrative (prodotti generici, prezzi di esempio).
// In futuro puoi aggiungere qui un campo `affiliateUrl` per collegare
// il link affiliato Amazon di ciascun prodotto.
export const PRODUCTS = [
    {
        id: "cuffie",
        name: "Cuffie Wireless con Cancellazione Attiva del Rumore",
        img: "https://images.pexels.com/photos/7772548/pexels-photo-7772548.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        oldPrice: "€79,99",
        price: "€39,99",
        discount: "-50%",
        category: "Audio",
        time: "19:42",
    },
    {
        id: "smartwatch",
        name: "Smartwatch Pro GPS, Display AMOLED",
        img: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?crop=entropy&cs=srgb&fm=jpg&q=85",
        oldPrice: "€129,99",
        price: "€79,99",
        discount: "-38%",
        category: "Tech",
        time: "19:15",
    },
    {
        id: "caffe",
        name: "Macchina Caffè Espresso Automatica",
        img: "https://images.unsplash.com/photo-1620807773206-49c1f2957417?crop=entropy&cs=srgb&fm=jpg&q=85",
        oldPrice: "€149,00",
        price: "€89,00",
        discount: "-40%",
        category: "Casa",
        time: "18:03",
    },
    {
        id: "robot",
        name: "Robot Vacuum Lavapavimenti Wi-Fi",
        img: "https://images.unsplash.com/photo-1653990480360-31a12ce9723e?crop=entropy&cs=srgb&fm=jpg&q=85",
        oldPrice: "€249,99",
        price: "€159,99",
        discount: "-36%",
        category: "Casa",
        time: "17:26",
    },
    {
        id: "tv",
        name: "Smart TV 4K UHD 50\" con Voice Control",
        img: "https://images.pexels.com/photos/5202925/pexels-photo-5202925.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        oldPrice: "€449,99",
        price: "€299,99",
        discount: "-33%",
        category: "Tech",
        time: "16:48",
    },
    {
        id: "sneakers",
        name: "Sneakers Running Uomo, Resp. Ultra-light",
        img: "https://images.unsplash.com/photo-1786379582186-83ef57a1c420?crop=entropy&cs=srgb&fm=jpg&q=85",
        oldPrice: "€89,99",
        price: "€49,99",
        discount: "-44%",
        category: "Sport",
        time: "16:12",
    },
];

export const FAQS = [
    {
        q: "Il canale Telegram è gratuito?",
        a: "Sì, l'accesso al canale è gratuito.",
    },
    {
        q: "Le offerte sono tutte Amazon?",
        a: "Il progetto è dedicato principalmente alle offerte disponibili su Amazon.",
    },
    {
        q: "Quanto durano le offerte?",
        a: "Dipende dal prodotto e dalla disponibilità. Alcune offerte possono terminare rapidamente.",
    },
    {
        q: "Devo pagare qualcosa?",
        a: "No. L'accesso al canale è gratuito.",
    },
    {
        q: "Come faccio a ricevere le offerte?",
        a: "Ti basta entrare nel canale Telegram e attivare le notifiche.",
    },
];

// ============================================================
// PAGINE LEGALI — dati del titolare (segnaposto da completare)
// ============================================================
export const LEGAL_META = {
    owner: "[TITOLARE DEL SITO]",
    email: "[EMAIL DI CONTATTO]",
    address: "[INDIRIZZO]",
    vat: "[PARTITA IVA, SE PRESENTE]",
    lastUpdated: "[DATA]",
    note: "I campi tra parentesi quadre […] sono segnaposto: devono essere completati con i dati reali del titolare prima della pubblicazione definitiva.",
};

// Ogni pagina è un elenco di sezioni: per modificare i contenuti
// basta agire su `h` (titolo), `ps` (paragrafi) e `list` (elenchi).
export const LEGAL_PAGES = {
    privacy: {
        title: "Privacy Policy",
        sections: [
            {
                id: "titolare",
                h: "Il titolare del trattamento",
                ps: [
                    "Il titolare del trattamento dei dati personali raccolti tramite questo sito è: [TITOLARE DEL SITO]. Contatti: [EMAIL DI CONTATTO] — [INDIRIZZO] — [PARTITA IVA, SE PRESENTE].",
                ],
            },
            {
                id: "dati-raccolti",
                h: "Quali dati personali raccogliamo",
                list: [
                    "Dati di navigazione: indirizzo IP, tipo di dispositivo e browser, sistema operativo, pagine visitate, orario degli accessi e altre informazioni tecniche trasmesse dal tuo dispositivo durante la navigazione.",
                    "Dati forniti volontariamente: se e quando attivi moduli di contatto o indirizzi email, i dati che decidi di comunicarci (ad esempio nome e indirizzo email) e il contenuto del messaggio.",
                    "Dati di misurazione: informazioni statistiche raccolte, anche in forma aggregata o pseudonimizzata, tramite gli eventuali strumenti di analytics descritti nella Cookie Policy.",
                    "Preferenze: le tue scelte relative a cookie e consenso, salvate localmente sul tuo dispositivo.",
                ],
                ps: [
                    "Non richiediamo registrazioni o account: non raccogliamo dati identificativi se non quando li fornisci volontariamente o quando vengono generati dalla semplice navigazione.",
                ],
            },
            {
                id: "finalita",
                h: "Perché raccogliamo i dati (finalità e basi giuridiche)",
                list: [
                    "Erogare il sito e garantirne funzionamento e sicurezza — base giuridica: esecuzione di misure precontrattuali e interesse legittimo del titolare.",
                    "Misurare in forma aggregata l'audience del sito, se e quando gli strumenti di analytics vengono attivati — base giuridica: consenso o interesse legittimo secondo la configurazione adottata.",
                    "Finalità di marketing e remarketing, se e quando strumenti di marketing vengono attivati — base giuridica: consenso, revocabile in qualsiasi momento.",
                    "Adempimenti di obblighi di legge, regolamenti o provvedimenti degli autorità competenti — base giuridica: obbligo legale.",
                ],
            },
            {
                id: "utilizzo",
                h: "Come utilizziamo i dati",
                ps: [
                    "I dati sono trattati con strumenti informatici e telematici, secondo i principi di correttezza, liceità e trasparenza previsti dalla normativa applicabile, e limitati a quanto necessario rispetto alle finalità perseguite.",
                    "Non vendiamo né cediamo i tuoi dati personali a terzi per finalità proprie di marketing.",
                ],
            },
            {
                id: "cookie",
                h: "Cookie e strumenti di tracciamento",
                ps: [
                    "Questo sito utilizza cookie e tecnologie simili. Una descrizione completa delle tipologie impiegate, delle finalità e delle modalità di gestione e revoca del consenso è disponibile nella Cookie Policy.",
                ],
            },
            {
                id: "analytics",
                h: "Strumenti di analytics",
                ps: [
                    "Il sito è predisposto per l'uso di Google Analytics e Google Tag Manager, attualmente NON attivi. Qualora vengano attivati, verranno impiegati per raccogliere statistiche d'uso in forma aggregata o pseudonimizzata (ad esempio pagine più visitate e provenienza degli accessi), nel rispetto della normativa applicabile e — dove richiesto — solo previo consenso.",
                    "Maggiori informazioni sono disponibili nell'informativa privacy di Google: https://policies.google.com/privacy.",
                ],
            },
            {
                id: "marketing",
                h: "Strumenti di marketing",
                ps: [
                    "Il sito è predisposto per l'uso del Meta Pixel (Facebook), attualmente NON attivo. Qualora venga attivato, servirà per misurare l'efficacia di eventuali campagne e per finalità di remarketing, esclusivamente previo consenso dell'utente.",
                    "Maggiori informazioni sono disponibili nell'informativa privacy di Meta: https://www.facebook.com/privacy/policies/.",
                ],
            },
            {
                id: "terze-parti",
                h: "Servizi di terze parti",
                list: [
                    "Amazon: il sito contiene link verso pagine di prodotti disponibili su Amazon, potenzialmente tramite link affiliati (vedi la pagina Affiliazione e trasparenza). Dopo il passaggio ad Amazon si applicano le informative di Amazon.",
                    "Telegram: il canale Telegram Sconti Incredibili è gestito su una piattaforma di terzi; l'adesione e l'uso del canale comportano il trattamento dei dati secondo le informative di Telegram.",
                    "Fornitori tecnici: servizi di hosting, CDN e sistemi di distribuzione di font e immagini (ad esempio Google Fonts, Fontshare, Unsplash, Pexels), che possono ricevere dati tecnici di navigazione per erogare i contenuti.",
                    "Analytics e marketing: Google Analytics, Google Tag Manager e Meta Pixel, predisposti ma non attivi (vedi le sezioni dedicate).",
                ],
            },
            {
                id: "moduli",
                h: "Dati raccolti tramite moduli di contatto",
                ps: [
                    "Qualora vengano attivati moduli di contatto o venga pubblicato un indirizzo email ([EMAIL DI CONTATTO]), i dati da te forniti verranno utilizzati esclusivamente per rispondere alle tue richieste e non per altre finalità senza il tuo consenso.",
                ],
            },
            {
                id: "conservazione",
                h: "Periodo di conservazione dei dati",
                ps: [
                    "I dati sono conservati per il tempo necessario alle finalità per cui sono stati raccolti: i dati di navigazione secondo la durata dei relativi cookie (vedi Cookie Policy); i dati forniti tramite contatti per il tempo necessario a gestire la richiesta e, salvo obblighi di legge, non oltre [PERIODO DI CONSERVAZIONE]; le preferenze di consenso fino a quando non vengono modificate o revocate.",
                ],
            },
            {
                id: "diritti",
                h: "Diritti dell'utente",
                ps: [
                    "Secondo gli artt. 15-22 del Regolamento UE 2016/679 (GDPR), puoi esercitare in qualsiasi momento i seguenti diritti:",
                ],
                list: [
                    "accesso ai dati e obtaining di una copia degli stessi;",
                    "rettifica dei dati inesatti o incompleti;",
                    "cancellazione dei dati («diritto all'oblio»);",
                    "limitazione del trattamento;",
                    "portabilità dei dati forniti;",
                    "opposizione al trattamento in determinate circostanze;",
                    "revoca del consenso, quando il trattamento vi si basi;",
                    "reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
                ],
            },
            {
                id: "esercizio-diritti",
                h: "Modalità per esercitare i propri diritti",
                ps: [
                    "Puoi esercitare i tuoi diritti in qualsiasi momento scrivendo a [EMAIL DI CONTATTO]. Ti risponderemo entro i termini previsti dalla normativa applicabile.",
                ],
            },
            {
                id: "amazon-esterni",
                h: "Amazon e link a siti esterni",
                ps: [
                    "Questo sito può contenere link a siti di terze parti, prima tra tutti Amazon. Una volta che lasci il sito e accedi a un sito esterno, il trattamento dei dati è regolato dalle informative del sito di destinazione, che ti invitiamo a consultare.",
                ],
            },
            {
                id: "aggiornamenti",
                h: "Aggiornamenti di questa informativa",
                ps: [
                    "Questa informativa può essere modificata in qualsiasi momento, anche in relazione all'attivazione di nuovi strumenti (ad esempio analytics o marketing). Ti invitiamo a consultare periodicamente questa pagina, facendo riferimento alla data di ultimo aggiornamento riportata in fondo.",
                ],
            },
        ],
    },

    cookie: {
        title: "Cookie Policy",
        sections: [
            {
                id: "cosa-sono",
                h: "Cosa sono i cookie",
                ps: [
                    "I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente durante la navigazione. Vengono utilizzati per garantire il funzionamento del sito, raccogliere statistiche e, in alcuni casi, mostrare contenuti personalizzati.",
                ],
            },
            {
                id: "tipologie",
                h: "Tipologie di cookie",
                list: [
                    "Cookie tecnici/necessari: indispensabili per il corretto funzionamento del sito (ad esempio la memorizzazione delle preferenze di consenso). Non richiedono il consenso dell'utente.",
                    "Cookie analitici: raccolgono statistiche aggregate sull'uso del sito (pagine visitate, durata della visita, provenienza degli accessi) al fine di migliorarne il funzionamento.",
                    "Cookie di profilazione/marketing: servono a creare profili utente sulla base delle preferenze manifestate durante la navigazione, per mostrare contenuti o annunci in linea con tali interessi.",
                    "Cookie di terze parti: installati da servizi di terzi (analytics, advertising, piattaforme esterne) e soggetti alle informative dei relativi fornitori.",
                ],
            },
            {
                id: "utilizzati",
                h: "Cookie effettivamente utilizzati da questo sito",
                ps: [
                    "Attualmente il sito utilizza solo tecnologie tecniche necessarie al suo funzionamento: in particolare, la memorizzazione locale (sul tuo dispositivo) delle preferenze relative a cookie e consenso.",
                    "Nessun cookie analitico o di profilazione è attualmente attivo.",
                ],
            },
            {
                id: "predisposti",
                h: "Strumenti predisposti, attualmente non attivi",
                ps: [
                    "Il sito è predisposto — ma NON attiva — i seguenti strumenti, che potrebbero essere attivati in futuro:",
                ],
                list: [
                    "Google Analytics (cookie analitici): statistiche d'uso in forma aggregata o pseudonimizzata.",
                    "Google Tag Manager (gestione di tag): gestione centralizzata di eventuali tracciamenti, senza finalità proprie.",
                    "Meta Pixel (cookie di profilazione/marketing): misurazione di campagne e, previo consenso, audience di remarketing.",
                ],
                ps2: [
                    "Quando e se attivati, questi strumenti verranno documentati in questa pagina e nella Privacy Policy, e verranno caricati esclusivamente dopo il consenso dell'utente.",
                ],
            },
            {
                id: "consenso",
                h: "Gestione del consenso",
                ps: [
                    "Alla prima visita viene mostrato un banner che consente di: accettare tutte le categorie non essenziali, rifiutarle, oppure scegliere di volta in volta quali abilitare (analytics, marketing).",
                    "Nessun cookie non essenziale viene attivato prima del tuo consenso. La scelta viene salvata sul tuo dispositivo e resta valida finché non la modifichi.",
                ],
            },
            {
                id: "revoca",
                h: "Modificare o revocare il consenso",
                ps: [
                    "Puoi modificare o revocare il tuo consenso in qualsiasi momento, in due modi:",
                ],
                list: [
                    "cliccando sul link «Preferenze cookie» presente nel footer del sito, che riapre il pannello di gestione;",
                    "cancellando o modificando le impostazioni di archiviazione del tuo browser.",
                ],
                ps2: [
                    "La revoca del consenso non pregiudica la liceità del trattamento effettuato sulla base del consenso prestato prima della revoca.",
                ],
            },
            {
                id: "google",
                h: "Google Analytics e Google Tag Manager",
                ps: [
                    "Se attivati, Google Analytics raccoglie dati d'uso tramite cookie di terza parte (ad esempio il cookie _ga, con durata indicativa fino a 24 mesi) utilizzati in forma aggregata o pseudonimizzata. Maggiori informazioni sono disponibili nelle informative di Google: https://policies.google.com/privacy e https://marketingplatform.google.com/about/analytics/terms/it/.",
                ],
            },
            {
                id: "meta",
                h: "Meta Pixel",
                ps: [
                    "Se attivato, il Meta Pixel consente a Meta di tracciare le visite al sito per misurare l'efficacia di eventuali campagne pubblicitarie e, previo consenso, definire audience di remarketing. I dati trattati e le modalità di trattamento sono descritti nell'informativa di Meta: https://www.facebook.com/privacy/policies/. La sua attivazione avverrà esclusivamente dopo il consenso dell'utente.",
                ],
            },
            {
                id: "altri-servizi",
                h: "Altri servizi di terze parti",
                ps: [
                    "Il sito carica contenuti da servizi esterni (ad esempio immagini da Unsplash e Pexels e caratteri da Fontshare e Google Fonts) e contiene link verso Amazon e verso Telegram. Questi servizi possono ricevere dati tecnici di navigazione (come l'indirizzo IP) per erogare i contenuti; per essi si applicano le rispettive informative.",
                ],
            },
            {
                id: "browser",
                h: "Disattivazione dei cookie dal browser",
                ps: [
                    "Puoi in ogni momento impostare il tuo browser per bloccare o cancellare i cookie tramite le relative impostazioni. La disattivazione dei cookie tecnici potrebbe compromettere il corretto funzionamento del sito.",
                ],
            },
            {
                id: "aggiornamenti",
                h: "Aggiornamenti di questa Cookie Policy",
                ps: [
                    "Questa pagina verrà aggiornata in caso di attivazione di nuovi strumenti o modifiche alla configurazione del sito. Ti invitiamo a consultarla periodicamente.",
                ],
            },
        ],
    },

    termini: {
        title: "Termini e Condizioni",
        sections: [
            {
                id: "oggetto",
                h: "Oggetto del servizio",
                ps: [
                    "Sconti Incredibili è un servizio informativo gratuito che si occupa di ricerca, selezione e segnalazione di offerte e prodotti disponibili principalmente su Amazon, pubblicati sul sito e sul relativo canale Telegram.",
                    "Sconti Incredibili è un servizio di segnalazione e aggregazione di offerte e non è il venditore dei prodotti mostrati.",
                ],
            },
            {
                id: "informazioni-prodotti",
                h: "Informazioni su prodotti e link verso Amazon",
                ps: [
                    "Il sito può mostrare informazioni relative a prodotti disponibili su Amazon e indirizzare l'utente verso Amazon tramite link, anche affiliati. Prezzo, disponibilità e condizioni finali sono quelli visualizzati sulla pagina del venditore o della piattaforma al momento dell'accesso.",
                ],
            },
            {
                id: "contratto",
                h: "Il contratto di acquisto",
                ps: [
                    "L'eventuale contratto di acquisto del prodotto viene concluso esclusivamente tra l'utente e il relativo venditore o la piattaforma di vendita (in particolare Amazon), secondo i termini e le condizioni applicabili su Amazon.",
                    "Sconti Incredibili non è parte del contratto e non interviene in alcun modo nella relazione tra utente e venditore.",
                ],
            },
            {
                id: "non-gestito",
                h: "Attività non gestite da Sconti Incredibili",
                ps: [
                    "Sconti Incredibili non gestisce e non è responsabile delle seguenti attività, per le quali si applicano le regole del venditore o della piattaforma di destinazione:",
                ],
                list: [
                    "pagamenti;",
                    "spedizioni;",
                    "resi;",
                    "rimborsi;",
                    "garanzie sui prodotti;",
                    "assistenza post-vendita;",
                    "disponibilità dei prodotti.",
                ],
            },
            {
                id: "cambiamenti",
                h: "Prezzi, disponibilità e cambiamenti",
                ps: [
                    "Prezzi, disponibilità, condizioni commerciali, promozioni e tempi di consegna possono cambiare in qualsiasi momento e senza preavviso.",
                    "L'utente deve verificare le informazioni direttamente sulla pagina Amazon (o della piattaforma di destinazione) prima di procedere all'acquisto.",
                ],
            },
            {
                id: "responsabilita-offerte",
                h: "Responsabilità sulle offerte",
                ps: [
                    "Noi troviamo e segnaliamo le offerte; prezzi, disponibilità e condizioni sono determinati dai relativi venditori e dalle piattaforme di vendita.",
                    "Amazon o il relativo venditore può modificare o terminare un'offerta in qualsiasi momento.",
                ],
            },
            {
                id: "telegram",
                h: "Il canale Telegram",
                ps: [
                    "L'accesso e l'utilizzo del canale Telegram Sconti Incredibili sono gratuiti e soggetti anche ai termini e alle informative di Telegram. L'attivazione delle notifiche è a discrezione dell'utente.",
                ],
            },
            {
                id: "affiliazione",
                h: "Link affiliati",
                ps: [
                    "Alcuni link presenti sul sito e/o nelle comunicazioni possono essere link affiliati. Per i dettagli consulta la pagina Affiliazione e trasparenza.",
                ],
            },
            {
                id: "marchi",
                h: "Marchi",
                ps: [
                    "Amazon e il logo Amazon sono marchi di Amazon.com, Inc. o delle sue affiliate. Sconti Incredibili non è affiliato, sponsorizzato o approvato da Amazon, salvo diversa indicazione. Tutti gli altri marchi menzionati appartengono ai rispettivi titolari.",
                ],
            },
            {
                id: "limitazione",
                h: "Limitazione di responsabilità",
                ps: [
                    "Il servizio è fornito «così com'è», senza garanzia circa la completezza, l'aggiornamento o la continuità delle informazioni pubblicate. Nei limiti consentiti dalla legge, Sconti Incredibili non risponde di danni derivanti da decisioni di acquisto prese sulla base delle informazioni pubblicate, né da malfunzionamenti o indisponibilità di piattaforme terze.",
                ],
            },
            {
                id: "link-esterni",
                h: "Link esterni",
                ps: [
                    "Il sito può contenere link verso Amazon e verso eventuali altri siti di terze parti. Non esercitiamo alcun controllo sui contenuti di tali siti: una volta lasciato il sito, si applicano le condizioni, la privacy policy e la cookie policy del sito di destinazione.",
                ],
            },
            {
                id: "modifiche",
                h: "Modifiche ai presenti Termini",
                ps: [
                    "I presenti Termini possono essere modificati in qualsiasi momento. L'uso continuativo del sito dopo la pubblicazione delle modifiche implica la conoscenza e l'accettazione dei Termini aggiornati. Ti invitiamo a consultare periodicamente la data di ultimo aggiornamento riportata in fondo alla pagina.",
                ],
            },
            {
                id: "legge",
                h: "Diritto applicabile e foro competente",
                ps: [
                    "I presenti Termini sono disciplinati dalla legge italiana. Per le controversie è previsto il foro di [FORO COMPETENTE], salvo i casi in cui la legge preveda il foro del consumatore.",
                ],
            },
            {
                id: "contatti",
                h: "Contatti",
                ps: [
                    "Per qualsiasi domanda sui presenti Termini puoi scrivere a: [EMAIL DI CONTATTO].",
                ],
            },
        ],
    },

    disclaimer: {
        title: "Disclaimer",
        sections: [
            {
                id: "non-amazon",
                h: "Sconti Incredibili non è Amazon",
                ps: [
                    "Sconti Incredibili non è Amazon e non rappresenta Amazon. Il sito ha lo scopo di segnalare e mostrare agli utenti offerte e prodotti disponibili presso piattaforme e venditori terzi.",
                ],
            },
            {
                id: "rapporto-amazon",
                h: "Rapporto con Amazon",
                ps: [
                    "Sconti Incredibili è un progetto indipendente e non è affiliato, sponsorizzato o approvato da Amazon, salvo quanto espressamente indicato. Amazon e i relativi marchi appartengono ai rispettivi titolari.",
                    "Qualora il progetto aderisca al Programma di Affiliazione Amazon, la dichiarazione ufficiale richiesta dalle condizioni del programma verrà riportata in questa pagina, con la formulazione prevista dal programma stesso. Non vengono effettuate dichiarazioni ufficiali a nome di Amazon.",
                ],
            },
            {
                id: "cambiamenti",
                h: "Le informazioni possono cambiare",
                list: [
                    "Le offerte possono cambiare in qualsiasi momento.",
                    "I prezzi possono cambiare in qualsiasi momento.",
                    "La disponibilità dei prodotti può cambiare in qualsiasi momento.",
                    "Una promozione può terminare senza preavviso.",
                    "Eventuali errori di prezzo o di descrizione possono essere corretti dal venditore o dalla piattaforma di vendita.",
                ],
            },
            {
                id: "condizioni-finali",
                h: "Prezzo e condizioni finali",
                ps: [
                    "Il prezzo e le condizioni finali dell'acquisto sono quelli visualizzati sulla pagina del venditore o della piattaforma al momento dell'acquisto. Nessuna informazione pubblicata su Sconti Incredibili sostituisce o prevale su quelle.",
                ],
            },
            {
                id: "nessuna-garanzia",
                h: "Nessuna garanzia sull'offerta",
                ps: [
                    "Non garantiamo che un'offerta sia disponibile, che un determinato prezzo rimanga invariato o che un prodotto soddisfi le tue aspettative.",
                    "Non affermiamo di creare gli sconti: noi troviamo e segnaliamo le offerte; prezzi, disponibilità e condizioni sono determinati dai relativi venditori e dalle piattaforme di vendita.",
                ],
            },
            {
                id: "contenuti-demo",
                h: "Contenuti dimostrativi",
                ps: [
                    "Le schede prodotto mostrate nella sezione «Offerte» del sito sono esempi generici a scopo dimostrativo e non rappresentano offerte attive, salvo diversa indicazione.",
                ],
            },
            {
                id: "link-esterni",
                h: "Link esterni",
                ps: [
                    "Il sito può contenere link verso Amazon e verso altri siti di terze parti. Una volta che l'utente lascia Sconti Incredibili e accede a un sito esterno, si applicano le condizioni, la privacy policy e la cookie policy del relativo sito.",
                ],
            },
            {
                id: "telegram",
                h: "Telegram",
                ps: [
                    "Il canale Telegram Sconti Incredibili opera sulla piattaforma Telegram, di proprietà di terzi. L'accesso e l'utilizzo del canale sono soggetti anche ai termini e alle informative di Telegram, che ti invitiamo a consultare. Sconti Incredibili non controlla i dati personali raccolti direttamente da Telegram.",
                ],
            },
        ],
    },

    affiliazione: {
        title: "Trasparenza sull'affiliazione",
        sections: [
            {
                id: "impegno",
                h: "Il nostro impegno",
                ps: [
                    "La fiducia degli utenti viene prima di tutto. Per questo spieghiamo in modo semplice come ci finanziamo e cosa significa, per te, la presenza di determinati link sul sito e sulle nostre comunicazioni.",
                ],
            },
            {
                id: "link-affiliati",
                h: "Cosa sono i link affiliati",
                ps: [
                    "Un link affiliato è un link che rimanda a un sito di e-commerce (ad esempio Amazon) e che contiene un codice che permette alla piattaforma di riconoscere la provenienza della visita.",
                    "Per te il funzionamento è identico a quello di un link normale: atterri sulla stessa pagina prodotto, allo stesso prezzo.",
                ],
            },
            {
                id: "come-funziona",
                h: "Come funziona per noi",
                ps: [
                    "Quando un utente clicca su un link affiliato e successivamente effettua un acquisto secondo le condizioni previste dal programma di affiliazione, potremmo ricevere una commissione su determinati acquisti effettuati tramite i nostri link.",
                    "La commissione viene corrisposta dalla piattaforma o dal programma di affiliazione e, salvo diversa indicazione, non comporta un costo aggiuntivo per l'utente.",
                ],
            },
            {
                id: "per-te",
                h: "Cosa non cambia per te",
                list: [
                    "Non paghi alcun costo aggiuntivo, salvo diversa indicazione.",
                    "Il prezzo finale che vedi sulla piattaforma non viene modificato dal nostro link.",
                    "La selezione delle offerte avviene secondo criteri editoriali indipendenti: la presenza o meno di un link affiliato non determina quali offerte segnaliamo.",
                ],
            },
            {
                id: "amazon",
                h: "Rapporto con Amazon",
                ps: [
                    "Sconti Incredibili è un progetto indipendente e non è affiliato, sponsorizzato o approvato da Amazon, salvo quanto espressamente indicato. Amazon e i relativi marchi appartengono ai rispettivi titolari.",
                    "[Se e quando il progetto aderisce al Programma di Affiliazione Amazon EU, inserire qui la dichiarazione ufficiale richiesta dalle condizioni del programma, nella formulazione prevista dal programma stesso.]",
                ],
            },
            {
                id: "altri-programmi",
                h: "Altri programmi e piattaforme",
                ps: [
                    "Questa pagina è strutturata per essere aggiornata in futuro in caso di adesione ad altri programmi di affiliazione, presenza su altri marketplace o sviluppo di nuovi canali (ad esempio newsletter, account utente o notifiche push). Ogni nuovo programma verrà documentato qui:",
                ],
                list: [
                    "[Programma di affiliazione: nome — Piattaforma: nome — Descrizione: …]",
                ],
            },
            {
                id: "aggiornamenti",
                h: "Aggiornamenti",
                ps: [
                    "Questa pagina può essere aggiornata in qualsiasi momento. Fai riferimento alla data di ultimo aggiornamento riportata in fondo.",
                ],
            },
        ],
    },
};
